<template>
    <ion-page>
      <ion-header class="headerTop ion-no-border">
        <headertoolbar></headertoolbar>
      </ion-header>
      <ion-content :fullscreen="true">
        <div class="original_main_container">
          <ion-header collapse="condense"></ion-header>
          <ion-icon class="l_close_a" button @click="this.$router.push('/admin/dashboard')"
            src="assets/ICONOS/close.svg"></ion-icon>
  
                <p class="tabTitle">Horas por Sucursal
                  <ion-icon class="config_icon_question" src="assets/ICONOS/questionmark.svg" 
                      @click="openInfoModal('Horas por Sucursal', 'Este reporte muestra la cantidad de tiempo que las sucursales reprodujeron contenido, dentro de un periodo de tiempo no mayor a un mes. Para mostrar información más precisa, este reporte se basa en las peticiones que hace cada sucursal al servidor… es decir, al finalizar una canción se realiza una segunda petición y eso suma el tiempo que estuvo al aire, si la sucursal esta al aire, pero el reproductor se encuentra pausado… este reporte no contará el tiempo en pausa.', 
  
  
  [
    {
      id: 0,
      mrg: 20,
      name: 'La tabla cuenta con una función de filtrado que facilita la búsqueda de contenidos específicos. También tiene un botón de \'Detalles\' que muestra una tabla emergente con la cantidad de audios reproducidos por día y las horas en línea:'
    },
    {
      id: 1,
      mrg: 10,
      name: ' 1. Titulo'
    },
    {
      id: 2,
      mrg: 10,
      name: ' 2. Horas (indica el tiempo al aire de la sucursal en horas y minutos)'
    },
    {
      id: 3,
      mrg: 20,
      name: '¡ALERTA! Este reporte se basa en análisis de logs, por lo que, si usted cuenta con muchas sucursales y estas reproducen mucho contenido, el reporte puede tardar en cargar. Si el reporte no carga, intente seleccionar un rango de fechas más corto.'
    }
    
  ])"
                      />
                    </p>
  
                  <select class="channel_select_e" ref="selectedChannel" v-model="selectedChannel" @change="handleChannelChange" aria-label="Canal" interface="popover" placeholder="Selecciona el canal">
                    <option v-for="item in channel_name_list" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
  
                  <ion-grid class="log_details_g">
                    <ion-row>
                      <ion-col class="mlog_date_div_es">
  
                          <ion-datetime v-model="date_from" class="spot_date_select spot_date_select_from"  :class="date_validation" @ionChange="handleDateChange" :min="minDate" :max="maxDate" display-format="DD/MM/YYYY" picker-format="DD/MM/YYYY" cancel-text="Cancelar" done-text="Aceptar"></ion-datetime>
                          
                          <ion-datetime v-model="date_to" class="spot_date_select spot_date_select_to"  :class="date_validation" @ionChange="handleDateChange" :min="minDate" :max="maxDate" display-format="DD/MM/YYYY" picker-format="DD/MM/YYYY" cancel-text="Cancelar" done-text="Aceptar"></ion-datetime>
  
                          <p class="alertaFechas" v-show="date_validation === 'menor'">
                            La fecha de inicio no puede ser mayor a la fecha final.
                          </p>
                          <p class="alertaFechas" v-show="date_validation === 'mayor'">
                            No se pueden consultar mas de 31 días en un solo reporte.
                          </p>
                          
                      </ion-col> 
                      <ion-col size="4" class="mlog_date_div_es_b">
                        <button class="cargar_reportes_button_sp sc-btn-3" @click="cargarReportes()">
                          <span>
                            Cargar Reportes
                          </span>
                        </button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                  
                  
                  
                  <ion-card v-if="alertaSinArchivos" color="warning" class="connectionalert outline-card" outline>
                    <ion-card-header>
                      <ion-card-title>Sin Registros.</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                      No existen registros para la fecha seleccionada.
                    </ion-card-content>
                  </ion-card>
  
                  
  
                  <div class="out_loader" v-if="isloading">
                    <div class="loader"></div>
                  </div>
                  
                  <div class="admin_report_filter">
                    <div class="m_count_l" v-show="mhora_s_table.length > 0 && !isloading">
                      Registros mostrados: {{ filteredLogs.length }} / {{ mhora_s_table.length }}
                    </div>

                    <div class="filter-input-con" v-show="mhora_s_table.length > 0 && !isloading">
                      <ion-input class="filterInput" placeholder="Filtrar por Titulo" @keyup="filterLogs" ref="textFilter"></ion-input>
                      <ion-icon class="filterIcon filtersearch" src="assets/ICONOS/search.svg"></ion-icon>
                      <ion-icon src="assets/ICONOS/close_f.svg" class="filterIcon filterclose" @click="if (this.$refs?.textFilter) this.$refs.textFilter.value = ''; filterLogs();"></ion-icon>
                      <div class="filter-excel-con">
                        <button class="exportButton" @click="exportToExcel">
                          <img src="img-admin/excel.png" >
                        </button>
                      </div>
                    </div>


                    <div class="m_count_r"  v-show="mhora_s_table.length > 0 && !isloading">
                      Registros mostrados: {{ filteredLogs.length }} / {{ mhora_s_table.length }}
                    </div>
                  </div>
  
                  <table v-show="mhora_s_table.length>0 && isloading == false" class="mhora_s_table">
                    <thead>
                      <tr>
                        <th class="title">Título</th>
                        <th class="seconds">Horas</th>
                        <th colspan="1" class="acciones">Acciones</th> 
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in filteredLogs" :key="item.url">
                        <td>{{ item.title }}</td>
                        <td>{{ formatSecondsToHours(item.seconds) }}</td>
                        <td class="accioness">
                          <a class="pp_detallesButton"
                            @click="openModal(item.title, item.logs)"
                          >
                            <ion-icon src="assets/ICONOS/detalles.svg"></ion-icon>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>  
                  
                  <div class="vMusicFloat" v-show="vMusicPlayerVisible">
                    <div class="vMusicDiv">
                      <a @click="vMusicPlayerClose" class="vMusicClose">
                        <ion-icon class="vMusicCloseIcon" src="assets/ICONOS/close_f.svg"></ion-icon>
                      </a>
                      <p>{{ vMusicPlayerName }}</p>
                      <audio id="vMusicPlayer" controls>
                        Your browser does not support the audio element.
                      </audio>
                    </div> 
                  </div>
                  <div class="bottom-space-on-float-audio" v-show="vMusicPlayerVisible"></div>
                  <br>
                  <br>
                  <br>
        </div>
      </ion-content>
      <!-- <ion-button @click="signOut" class="logoutButtonCabina"><ion-icon src="assets/ICONOS/cabina/log-out-outline.svg"></ion-icon>Cerrar sesión</ion-button> -->
    </ion-page>
  </template>
  
  
  <script>
  /* eslint-disable */
  import { alertController, IonPage, IonHeader, IonToolbar, IonContent, IonRefresher, IonRefresherContent, IonDatetime, modalController } from '@ionic/vue';
  import axios from 'axios';
  import { defineComponent } from 'vue';
  import { Storage } from '@capacitor/storage';
  import headertoolbar from '../header_toolbar.vue';
  import { Capacitor } from '@capacitor/core';
  import 'url-polyfill';
  import 'blob-polyfill'; 
  import { max, min } from 'moment-timezone';
  import moment from 'moment';
  import * as XLSX from 'xlsx';
  
  
  import sucHoraListModal from '../sucHoraListModal.vue';
  import infoModal from '../infoModal.vue';
  //import { toastController } from '@ionic/vue';
  
  export default ({
    name: 'Reproductor',
    components: { IonHeader, IonToolbar, IonContent, IonPage, headertoolbar, IonRefresher, IonRefresherContent, IonDatetime },
    data() {
      return {
        urlApi: 'https://panel.vybroo.net/',
        clientData: null,  
        token: null,
        serverDate: null,
        clientData: {}, 
        channel_name_list: [],
        channel_list: [],
        selectedChannel: null,
        alertaSinArchivos: false,
        isloading: true,
        dashboard: 
          {
            client: {
              email: "",
              id: 0,
              name: "",
              obligation: 0,
              retainer: 0
            },
            radio: {
              blacklist: "",
              branches: 0,
              categories: "",
              image: "2f07f7cfc8d4348937078a566c7d943e.png",
              link: "",
              mobileimage: "6b8b53effc9683373db10671d4bf0687.png",
              name: "",
              tags_blacklist: "",
              video_enabled: false
            },
            spots: {
              id: 0,
              level: 0,
              month: "",
              name: "",
              obligation: 0,
              percentage: "",
              produced: null,
              year: ""
            },
          },
          date_from: moment().startOf('month').format('YYYY-MM-DD'),
          date_to: moment().subtract(1, 'day').format('YYYY-MM-DD'),
          minDate: '2023-01-01',
          maxDate: moment().subtract(1, 'day').format('YYYY-MM-DD'),
          date_validation: 'ok',
          mhora_s_table: [],
          filteredLogs: [],
          logTitleObj: {},
          muteado: false,
          vMusicPlayerName: null,
          vMusicPlayerVisible: false,
          alertaSinArvhivos: false,
          reportName: '',
          reportFirstPage: '',
  
      }
    },
    methods: {  
      exportToExcel() {
      const workbook = XLSX.utils.book_new();

      // Crear la primera hoja con el concentrado
      const summaryData = this.getSummaryData();
      const summarySheet = XLSX.utils.json_to_sheet(summaryData);
      
        let sheetName1 = this.reportFirstPage;
        if (sheetName1.length > 30) {
          sheetName1 = sheetName1.replace(/[\\/:?*\[\]]/g, '').substring(0, 27) + '...';
        }

      XLSX.utils.book_append_sheet(workbook, summarySheet, sheetName1);

      // Crear una hoja de trabajo para cada sucursal
      this.mhora_s_table.forEach((item, index) => {
        const tableData = this.getTableData(item);
        const worksheet = XLSX.utils.json_to_sheet(tableData);
        let sheetName2 = item.title;
        if (sheetName2.length > 30) {
          sheetName2 = sheetName2.substring(0, 27) + '...';
        }
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName2);
      });

      // Generar el archivo Excel
      XLSX.writeFile(workbook, this.reportName + ".xlsx");
    },

    // Método para obtener los datos del concentrado
    getSummaryData() {
      const summaryData = [];
      this.mhora_s_table.forEach(item => {
        summaryData.push({  
          Sucursal: item.title,
          Horas: this.formatSecondsToHours(item.seconds),
          Minutos_Totales: Math.round(item.seconds / 60),
        });
      });
      return summaryData;
    },

    // Método para obtener los datos de la tabla
    getTableData(item) {
      const tableData = [];
      item.logs.forEach(log => {
        tableData.push({
          Fecha: log.date, 
          Horas: this.formatSecondsToHours(log.seconds),
          Minutos_Totales: Math.round(log.seconds / 60),
        });
      });
      return tableData;
    },
      async openInfoModal(title, desc, list) {
        const modal = await modalController.create({
          component: infoModal,
          componentProps: {
            title: title,
            desc: desc,
            list: list,
          },
        });
        return modal.present();
      },
      async openModal(title, array) {
        const modal = await modalController.create({
          component: sucHoraListModal,
          componentProps: {
            title: title,
            array: array,
          },
        });
        return modal.present();
      },
      formatSecondsToHours(seconds) {
          const hours = Math.floor(seconds / 3600);
          const minutes = Math.floor((seconds % 3600) / 60);
          return `${hours}h ${minutes}m`;
      }, 
      filterLogs() {
        const safeText = (value) => String(value ?? '').toLowerCase();
        const filter = safeText(this.$refs?.textFilter?.value);
        this.mhora_s_table.sort((a, b) => a.title.localeCompare(b.title));
        this.filteredLogs = this.mhora_s_table.filter(log => {
          return safeText(log.title).includes(filter);
        }); 
      },
      handleChannelChange(event) { 
        this.selectedChannel = event.target.value;
        this.emitter.emit("selectedChannel", event.target.value);
                Storage.set({
                  key: "cabina_admin_selectedChannel",
                  value: this.selectedChannel,
                });   
      },
      firstLoad() { 
        this.selectedChannel = this.$refs.selectedChannel.value;
        console.log("firstLoad::DASHBOARD: ", this.selectedChannel);
        this.emitter.emit("selectedChannel", this.selectedChannel);
                Storage.set({
                  key: "cabina_admin_selectedChannel",
                  value: this.selectedChannel,
                });  
        this.isloading = false;
      },
      handleDateChange() {
        console.log("handleDateChange::Obteniendo handleDateChange...");
        if (this.date_from > this.date_to) {
           this.date_validation = 'menor';
           this.date_to = this.date_from;
        } else {
          if (moment(this.date_to).diff(moment(this.date_from), 'days') > 31) {
            this.date_validation = 'mayor';
          }else{
            this.date_validation = 'ok';
          }
        }
      },
async cargarReportes() {
  this.alertaSinArvhivos = false;
  if (this.date_from > this.date_to) {
    const alert = await alertController.create({
      header: "Aviso",
      message: "La fecha de inicio no puede ser mayor a la fecha final.",
      buttons: [{ text: 'Aceptar' }]
    });
    return alert.present();
  }
  if (moment(this.date_to).diff(moment(this.date_from), 'days') > 31) {
    const alert = await alertController.create({
      header: "Aviso",
      message: "El rango de fechas no puede ser mayor a 31 días.",
      buttons: [{ text: 'Aceptar' }]
    });
    return alert.present();
  }

  this.isloading = true;
  this.mhora_s_table = [];
  this.logTitleObj = {};

  try {
    // Prepara los parámetros
    const stream = this.dashboard.radio.stream || this.selectedChannel;
    const from = moment(this.date_from).format('YYYY-MM-DD');
    const to = moment(this.date_to).format('YYYY-MM-DD');
    const token = this.token;
          let url = "api/daily_summaries";
          if (Capacitor.getPlatform() == 'ios') url = "https://panel.vybroo.net/daily_summaries";
 
    // Llama al endpoint
    const response = await axios.post(url, {
      stream,
      from,
      to,
      token
    });

    const data = response.data;

    // Maneja la respuesta
    if (data.success && Array.isArray(data.sucursales)) {
      this.reportName = `Reporte de Horas por Sucursal ${data.radio_name} del ${from} al ${to}`;
      this.reportFirstPage = data.radio_name;

      this.mhora_s_table = data.sucursales.map(suc => ({
        title: suc.sucursal,
        count: suc.daily_detail.reduce((acc, d) => acc + (d.minutes > 0 ? 1 : 0), 0),
        seconds: suc.total_minutes * 60,
        logs: suc.daily_detail.map(d => ({
          date: d.date,
          seconds: d.minutes * 60,
          count: d.minutes > 0 ? 1 : 0
        }))
      }));

      this.mhora_s_table.sort((a, b) => b.count - a.count);

      if (this.mhora_s_table.length <= 0) {
        this.alertaSinArvhivos = true;
      }
    } else {
      this.alertaSinArvhivos = true;
    }

    this.filterLogs();
    this.isloading = false;
  } catch (error) {
    this.isloading = false;
    this.alertaSinArvhivos = true;
  }
},

      async presentAlertConfirm(headerAlert, messageAlert, buttonTextConfirm, buttonTextCancel, functionConfirm, functionCancel) {
        const alert = await alertController
          .create({
            header: headerAlert,
            message: messageAlert,
            buttons: [
              {
                text: buttonTextConfirm,
                handler: () => {
                  functionConfirm();
                }
              },
              {
                text: buttonTextCancel,
                handler: () => {
                  functionCancel();
                }
              }
            ]
          });
        return alert.present();
      },
      async signOut() {
        const alert = await alertController
          .create({
            header: "Aviso",
            message: "¿Estás seguro que deseas cerrar la sesión?",
            buttons: [
              {
                text: 'Si',
                handler: () => {
                  Storage.remove({ key: 'authToken' });
                  Storage.remove({ key: 'cabina_admin_user' });
                  Storage.remove({ key: 'cabina_admin_channel_list' });
                  Storage.remove({ key: 'cabina_admin_selectedChannel' });
                  this.$router.replace("/admin/LoginAdmin");
                  this.emitter.emit('cabina_admin_user', '',);
                  this.emitter.emit('cabina_admin_channel_list', '',);
                }
              },
              {
                text: 'Cancelar',
                handler: () => {
                  //console.log('Cancelar pulsado');
                }
              },
            ]
          });
        return alert.present();
  
      }, 
      async getStorageClientData(keyName) {
        try {
          const ret = await Storage.get({ key: keyName });
          this.clientData = this.isJson(ret.value);
        } catch (error) {
          //console.log("Error en función getStorageClientData de Conexiones: " + error.message);
        }
      }, 
      isJson(str) {
        try {
          const parsedStr = JSON.parse(str);
          return parsedStr;
        } catch (e) {
          return str;
        }
      },
      async getStorageAuthToken() {
        try {
          //console.log("Obteniendo token del storage...")
          const ret = await Storage.get({ key: 'authToken' });
          if (ret.value) {
            const tokenObj = JSON.parse(ret.value);
            this.token = tokenObj.value;
            //console.log("Token obtenido: " + this.token);
            // console.log("Token obtenido:" + this.token)
            return this.validateToken(this.token);
          } else {
            //console.log("Token no encontrado");
            this.presentAlertTokenInvalid();
            return false;
          }
        } catch (error) {
          //console.log("Error en función getStorageAuthToken de Conexiones: " + error.message);
        }
      },
      async presentAlertTokenInvalid() {
        const alert = await alertController
          .create({
            header: "Aviso",
            message: "Tu sesión ha expirado, por favor inicia sesión nuevamente",
            buttons: [
              {
                text: 'Aceptar',
                handler: () => {
                  this.$router.replace("/admin/LoginAdmin");
                }
              },
            ]
          });
        return alert.present();
      },
      async validateToken(token) {
        try {
          //console.log("revisando validez de token: " + token + " ...");
          if (token == null || token == undefined || token == "") {
            this.presentAlertTokenInvalid();
            return false;
          }
          if (token != null && token != undefined && token != "") {
            let url = "api/user_auth";
            if (Capacitor.getPlatform() == 'ios') url = "https://panel.vybroo.net/user_auth";
            let response = await axios.post(url, { token: token })
              .then(r => {
                //console.log("r.data:");
                //console.log(r.data);
                return r;
              }).catch(error => {
                //console.log("3Error en función validateToken de Conexiones: " + error.message);
                return error;
              });
            //console.log("response.data:");
            //console.log(response.data);
            //console.log("response.data.success: " + response.data.success);
            //console.log("response.data.error: " + response.data.error);
            if (response.data.error === true) {
              //console.log("Error al validar token:");
              //console.log(response.data);
              this.presentAlertTokenInvalid();
              return false;
            }
            if (response.data.success === true) {
              //console.log("Token válido");
              return true;
            } else {
              //console.log("Token inválido");
              //console.log("2response.data.success: " + response.data.success);
              //console.log("2response.data.error: " + response.data.error);
              this.presentAlertTokenInvalid();
              return false;
            }
          }
        } catch (error) {
          //console.log("4Error en función validateToken de Conexiones: " + error.message);
          return false;
        }
      },
      async getFullClientData() {
        try {
          const ret = await Storage.get({ key: "clientData" });
          if (ret.value) {
            this.clientData = JSON.parse(ret.value);
            //console.log("Recuperado de storage, key: clientData - " + this.clientData);
  
            if (this.clientData.sonara) {
              this.emitter.emit("sonara", true);
            } else {
              this.emitter.emit("sonara", false);
            }
          } else {
            //console.log("No se pudo recuperar de storage, key: clientData - " + this.clientData);
          }
        } catch (e) {
          this.presentAlertConfirm("Ha ocurrido un error en la función getFullClientData", e);
        }
      },
      async getChannelList(){
        try {
          const ret = await Storage.get({ key: "cabina_admin_channel_list" });
          if (ret.value) { 
              this.channel_list = JSON.parse(ret.value).slice();
              this.emitter.emit("channel_list", this.channel_list);
              this.channel_name_list = [];
              if (this.channel_list){
                this.channel_list.forEach(element => {
                  this.channel_name_list.push({ id: element.id, name: element.name });
                });
                this.emitter.emit("channel_name_list", this.channel_name_list);
                //console.log("Recuperado de storage, key: cabina_admin_channel_list - " , this.channel_list);
                //console.log("Recuperado de storage, key: channel_name_list - " , this.channel_name_list);
                if (this.selectedChannel == [] || this.selectedChannel == null || this.selectedChannel == undefined) {
                  const selectedChannelAux = await Storage.get({ key: "cabina_admin_selectedChannel" });
                  //console.log("selectedChannelAux: " , selectedChannelAux);
                  if (selectedChannelAux.value) {
                    this.selectedChannel = selectedChannelAux.value;
                    this.emitter.emit("selectedChannel", this.selectedChannel);
                    Storage.set({
                      key: "cabina_admin_selectedChannel",
                      value: this.selectedChannel,
                    });
                  } else {
                    this.selectedChannel = this.channel_list[0].id;
                    this.loadChannelDashboard(this.selectedChannel);
                    this.emitter.emit("selectedChannel", this.selectedChannel);
                    Storage.set({
                      key: "cabina_admin_selectedChannel",
                      value: this.selectedChannel,
                    });
                  }
                  //this.selectedChannel = this.channel_list[0].id;
                  //this.loadChannelDashboard(this.selectedChannel);
                  //this.emitter.emit("selectedChannel", this.selectedChannel);
                }
              }
          } else {
            console.log("No se pudo recuperar de storage, key: cabina_admin_channel_list - " , this.channel_list);
          }
        } catch (error) {
          console.log("Error en función cabina_admin_channel_list de Dashboard: " , error.message);
          return false;
        }
      }
    },
    mounted: function () { 
  setTimeout(() => {
  
      try {
        if (Capacitor.getPlatform() == 'ios') {
          this.urlApi = "https://panel.vybroo.net/";
        } else {
          this.urlApi = "/api/";
        } 
  
        //get auth token de storage y asignarlo a la variable token
        this.getStorageAuthToken();
        this.getStorageClientData('clientData');
        this.getChannelList();
  
        this._onSelectedChannel = (channel) => { this.selectedChannel = channel; };
        this._onChannelList = (channel_list) => { this.channel_list = channel_list; };
        this._onChannelNameList = (channel_name_list) => { this.channel_name_list = channel_name_list; };
        this._onDashboard = (dashboard) => { this.dashboard = dashboard; };
        this.emitter.on("selectedChannel", this._onSelectedChannel);
        this.emitter.on("channel_list", this._onChannelList);
        this.emitter.on("channel_name_list", this._onChannelNameList);
        this.emitter.on("dashboard", this._onDashboard);
   
      } catch (error) {
        console.log("Error en función mounted de Conexiones: " + error.message);
      }
  
       
  }, 1000);
  setTimeout(() => {
    this.firstLoad();
  }, 2000);
    },
    beforeUnmount() {
      if (this._onSelectedChannel) this.emitter.off("selectedChannel", this._onSelectedChannel);
      if (this._onChannelList) this.emitter.off("channel_list", this._onChannelList);
      if (this._onChannelNameList) this.emitter.off("channel_name_list", this._onChannelNameList);
      if (this._onDashboard) this.emitter.off("dashboard", this._onDashboard);
    },
    
  
  })
  </script>
  <style lang="css"> 
  .bottom-space-on-float-audio {
    height: 100px;
  }
  .pp_detallesButton {
    cursor: pointer;
    text-align: center;
    width: 22px;
    display: block;
    margin: auto;
  }
  .pp_escucharButton {
    cursor: pointer;
    text-align: center;
    width: 22px;
    display: block;
    margin: auto;
  }
  .pp_escucharButton .vvplay {
    display: block;
    margin: auto;
  }
  .pp_escucharButton .vvpausa {
    display: none;
    animation: pulse .5s infinite;
    margin: auto;
  } 
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
  
  .pp_escucharButton:hover .vvplay {
    scale: 1.2;
  }
  .pp_escucharButton:hover .vvpausa {
    scale: 1.2;
  }
  .pp_escucharButton.activo .vvplay {
    display: none;
  }
  .pp_escucharButton.activo .vvpausa {
    display: block;
  }
  .pp_detallesButton ion-icon {
    width: 22px;
    height: 22px;
  }
  .pp_detallesButton ion-icon:hover {
    scale: 1.2;
  }
  .vMusicFloat{
    position: fixed;
      bottom: 20px;
      left: 50%;
      background-color: #000000;
      color: #ffffff;
      z-index: 1000;
      border: solid 1px #ccc;
      padding: 0px 15px;
      width: 420px;
      transform: translateX(-50%);
      border-radius: 7px;
      box-shadow: 0px 0px 20px RGBA(0,0,0,.5);
  }
  .vMusicFloat #vMusicPlayer{
    width: 100%;
  }
  .vMusicFloat .vMusicDiv {
     padding: 6px 2px 10px 2px;
  }
  .vMusicFloat .vMusicDiv p {
     width: calc(100% - 20px);
      text-align: left;
      font-size: 1.1em;
      font-weight: 600;
      margin: 0px;
      padding: 10px 0px;  
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
  .vMusicFloat .vMusicClose{
    position: absolute;
    right: 10px;
    top: 10px;
    color: #ffffff;
    cursor: pointer;
  
  }
  .vMusicFloat .vMusicCloseIcon{
    width: 20px;
    height: 20px;
  }
  .vMusicFloat .vMusicClose:hover{
    scale: 1.2; 
  }
   
  
  /* PRETTY BUTTON ------------*/
  .cargar_reportes_button_sp {
    width: 130px;
    height: 40px;
    color: #fff;
    padding: 10px 25px;
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
      7px 7px 20px 0px rgba(0, 0, 0, .1),
      4px 4px 5px 0px rgba(0, 0, 0, .1);
    outline: none;
    margin: 0px 0px;
    display: block;
  }
  .sc-btn-3 {
    color: white;
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
    font-weight: bold;
    font-size: 16px;
    background: linear-gradient(0deg, #2dd36f 0%, #2dd36f 100%);
    width: 180px;
    height: 40px;
    line-height: 42px;
    padding: 0;
    border: none;
  
  }
  .sc-btn-3 span {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
  }
  .sc-btn-3:before,
  .sc-btn-3:after {
    position: absolute;
    content: "";
    right: 0;
    top: 0;
    background: #2dd36f;
    transition: all 0.3s ease;
  }
  .sc-btn-3:before {
    height: 0%;
    width: 2px;
  }
  .sc-btn-3:after {
    width: 0%;
    height: 2px;
  }
  .sc-btn-3:hover {
    background: transparent;
    color: #2dd36f;
    font-weight: bold;
    box-shadow: none;
  }
  .sc-btn-3:hover:before {
    height: 100%;
  }
  .sc-btn-3:hover:after {
    width: 100%;
  }
  .sc-btn-3 span:hover {
    color: #2dd36f;
  }
  .sc-btn-3 span:before,
  .sc-btn-3 span:after {
    position: absolute;
    content: "";
    left: 0;
    bottom: 0;
    background: #2dd36f;
    transition: all 0.3s ease;
  }
  .sc-btn-3 span:before {
    width: 2px;
    height: 0%;
  }
  .sc-btn-3 span:after {
    width: 0%;
    height: 2px;
  }
  .sc-btn-3 span:hover:before {
    height: 100%;
  }
  .sc-btn-3 span:hover:after {
    width: 100%;
  }
  
  .spot_date_select { 
      margin: 0 0 0 8px;
      padding: 10px;
      border-radius: 5px;
      border: solid 1px #232323;
      background-color: #000000;
      color: #ffffff;
      font-size: 1em;
      font-weight: 400;
      margin-bottom: 10px;
  }
  .spot_date_select_from,
  .spot_date_select_to {
      width: 50% !important; 
  }
  .mlog_date_div_es .alertaFechas {
    color: #ff4343;
      font-size: 12px;
      position: absolute;
      bottom: -43px;
      background: black;
      border-radius: 6px;
      padding: 4px 7px;
      border: solid red 1px;
      width: calc(100% - 20px);
      left: calc(50% + 4px);
      transform: translateX(-50%);
      display: none;
      z-index: 1000;
  }
  .mlog_date_div_es:hover .alertaFechas {
    display: block;
  }
  .mlog_date_div_es .alertaFechas:before{
    content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid red;
      top: -6px;
      left: calc(50% - 6px);
  
  }
  .mlog_date_div_es{
    width: 280px !important;
    max-width: 280px !important;
    min-width: 280px !important;
    display: flex;
  }
  .mlog_date_div_es_b{
    width: calc(100% - 280px) !important;
    max-width: calc(100% - 280px) !important;
    min-width: calc(100% - 280px) !important;
    display: flex;
    text-align: right;
  }
 
  .log_details_g{ 
    padding: 0px !important;
  }
  
  .mhora_s_table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
    font-size: 1em;
    font-weight: 400;
    color: #ffffff;
    background-color: #000000;
    border-radius: 5px;
    border: solid 1px #232323;
  }
  .mhora_s_table th {
    padding: 5px;
    border-bottom: solid 1px #232323;
    text-align: left;
  }
  .mhora_s_table td {
    padding: 5px;
    border-bottom: solid 1px #232323;
    text-align: left;
  }
  .mhora_s_table tr:hover{
    background-color: #232323;
  } 
  
  .mhora_s_table th {
    position: sticky;
    top: 0;
    background-color: #000000;
    z-index: 1;
  } 
  .mhora_s_table th:nth-child(1) {
     
  } 
  .mhora_s_table .acciones {
    width: 24px;
    text-align: center
  }
  .mhora_s_table td.accioness {
    width: 50px;
  } 
  .mhora_s_table .count { 
    cursor: help;
  }
  .mhora_s_table .count:hover {
    background: #363636;
  }
  .mhora_s_table .count:hover:before {
      content: 'Numero de Audios totales';
      position: absolute;
      background-color: #363636;
      color: #fff;
      padding: 10px 15px;
      border-radius: 5px;
      font-size: 12px;
      left: 0;
      top: 25px;
      border: solid 1px #232323;
      z-index: 2000;
  }
  .mhora_s_table .accioness .pp_escucharButton,
  .mhora_s_table .accioness .pp_detallesButton{
     position: relative;
  }
  
  .mhora_s_table .accioness .pp_escucharButton:hover ion-icon,
  .mhora_s_table .accioness .pp_detallesButton:hover ion-icon{ 
    filter: brightness(0.8);
  }
  .mhora_s_table .accioness .pp_escucharButton:hover:before{
      content: 'Escuchar';
      position: absolute;
      background-color: #363636;
      color: #fff;
      padding: 10px 15px;
      border-radius: 5px;
      font-size: 12px;
      left: 0;
      top: 25px;
      border: solid 1px #232323;
      z-index: 2000;
  }
  .mhora_s_table .accioness .pp_escucharButton.activo:hover:before{
      content: 'Escuchando';
  }
  .mhora_s_table .accioness .pp_detallesButton:hover:before{  
      content: 'Detalles';
      position: absolute;
      background-color: #363636;
      color: #fff;
      padding: 10px 15px;
      border-radius: 5px;
      font-size: 12px;
      left: 0;
      top: 25px;
      border: solid 1px #232323;
      z-index: 2000;
  }
  @media (max-width: 767px) {
    .mhora_s_table {
      width: 100%;
          max-width: 100%;
          height: calc(100vh - 400px);
          overflow: auto !important;
    }
    .mhora_s_table th {
      position: sticky;
      top: 0;
      background-color: #000000;
      z-index: 1;
    }
 
  }
  
  
  
  .mlog_date_div_es > .spot_date_select_from.menor,
  .mlog_date_div_es > .spot_date_select_to.menor {
    border: solid 1px #ff4f4f;
  }
  .mlog_date_div_es > .spot_date_select_from.mayor,
  .mlog_date_div_es > .spot_date_select_to.mayor {
    border: solid 1px #ff4f4f;
  }
  .mlog_date_div_es > .spot_date_select_from.ok,
  .mlog_date_div_es > .spot_date_select_to.ok {
    border: solid 1px #232323;
  }
   
  
  </style>